<template>
<div>
    <div class="form-group" v-if="!productionAdminEdit && !qaqcEnabled && isShpoCr" style="margin-bottom: 20px;">
        <label class="col-md-2 control-label text-label">SHPO CR Notes</label>
        <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
            <textarea class="form-control" rows="4" v-model="culturalResourceRecording.shpoCrRecordingNotes"/>
        </div>
        <fieldset :disabled="formDisabled">
            <template v-if="isNormalization" class="form-group">
                <label  class="col-md-2 control-label text-label">Add Site Form Link to Notes</label>
                <div class="col-md-4">
                    <select class="form-control" v-model="selectedOtherCrrId">
                        <option :value="null" disabled>Select</option>
                        <option v-for="crr in otherCrrList" v-bind:value="crr.culturalResourceRecordingId" :key="crr.culturalResourceRecordingId">
                            {{ crr.smithsonianNumber + " - " + crr.culturalResourceRecordingId }}
                        </option>
                    </select>
                    <button style="margin: 5px" class="btn btn-default" v-on:click="insertCrrLinkToNotes">Insert</button>
                </div>
            </template>
        </fieldset>
    </div>
    <div class="form-group" v-if="!productionAdminEdit && !qaqcEnabled" style="margin-bottom: 20px;">
        <fieldset :disabled="formDisabled">
            <label class="col-md-2 control-label text-label">Recorded By</label>
            <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
                <input type="text" v-model="culturalResourceRecording.recordedBy" class="form-control" :style="qaqcInputStype">
                <!-- <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'recordedBy'" :hasAppend="false"></qaqcFormFieldSelect> -->
            </div>
            <label class="col-md-2 control-label text-label">Field Date</label>
            <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
                <el-date-picker v-model="culturalResourceRecording.fieldDate" type="date" format="MM/dd/yyyy" placeholder="Select Date" :disabled="formDisabled"></el-date-picker>
                <input name="fieldDate" type="hidden" v-model="culturalResourceRecording.fieldDate" />
                <!-- <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'fieldDate'" :hasAppend="false"></qaqcFormFieldSelect> -->
            </div>
            <label class="col-md-2 control-label text-label">Recording Organization</label>
            <div class="col-md-4 text-label">
                <span>{{recordingOrganization}}</span>
            </div>
        </fieldset>
    </div>
    <div class="form-group">
        <fieldset :disabled="formDisabled">
            <label class="col-md-2 control-label text-label">Smithsonian Number</label>
            <div class="col-md-4 text-label">
                <a v-on:click="goProduction" v-if="!productionAdminEdit">{{culturalResource.smithsonianNumber}}</a>
                <span v-else>{{culturalResource.smithsonianNumber}}</span>
                <div class="pull-right" v-if="isMigrated">
                    <h4><span class="label label-default" style="color: #FFFFFF">Migrated</span></h4>        
                </div>
            </div>
            <label class="col-md-2 control-label text-label">Record Type</label>
            <div class="col-md-4 text-label">
                {{culturalResourceRecording.recordingTypeDescription}}
                <div v-if="productionAdminEdit" class="form-group">
                    <label class="control-label text-label" for="isNoFormOnFile" style="color:red;">No Form on File</label>
                    <input type="checkbox" v-model="culturalResource.isNoFormOnFile" class="form-check-input" id="isNoFormOnFile" style="width: 15px; height: 15px;"/>
                </div>
            </div>
        </fieldset>
    </div>
    <div class="form-group">
        <fieldset :disabled="formDisabled">
            <label class="col-md-2 control-label text-label">Site Name</label>
            <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
                <input type="text" v-model="culturalResourceRecording.siteName" class="form-control" :style="qaqcInputStype">
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'siteName'" :hasAppend="false"></qaqcFormFieldSelect>
            </div>
            <label class="col-md-2 control-label text-label">Member of District or Linear</label>
            <div class="col-md-4">
                <div class="text-label">{{culturalResource.grouping}}
                <a class="fa fa-edit" :class="{ 'disabled-link': formDisabled }" style="margin-left: 10px; font-size: 18px;" v-on:click="goCulturalResourceGroup()"></a>
                </div>
            </div>
        </fieldset>
    </div>
    <div class="form-group">
        <fieldset :disabled="formDisabled">
            <label class="col-md-2 control-label text-label">
                Property Category
            </label>
            <div class="col-md-4 text-label" v-if="!(productionAdminEdit || isFirstOrFullRecord || qaqcEnabled)">
                {{culturalResourceRecording.siteTypeDescription}}
            </div>
            <div v-else class="col-md-4" :class="{'form-inline': qaqcEnabled}">
                <select name="siteTypeId" class="form-control" v-model="culturalResourceRecording.siteTypeId" :style="qaqcInputStype">
                    <option disabled value="">Select a value</option>
                    <option v-for="siteType in siteTypeList" :key="siteType.siteTypeId" :value="siteType.siteTypeId">
                        {{ siteType.description}}
                    </option>
                </select>
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'siteTypeId'" :hasAppend="false"></qaqcFormFieldSelect>
            </div>
            <label class="col-md-2 control-label text-label">
                Time Period
            </label>
            <div class="col-md-4 text-label" v-if="!(productionAdminEdit || isFirstOrFullRecord || qaqcEnabled)">
                {{culturalResourceRecording.timePeriodDescription}}
            </div>
            <div class="col-md-4" v-else :class="{'form-inline': qaqcEnabled}">
                <select class="form-control" v-model="culturalResourceRecording.timePeriodId" :style="qaqcInputStype">
                    <option :value="null" disabled>Select a value</option>
                    <option v-for="period in timePeriodList" :key="period.id" :value="period.id">{{period.description}}</option>
                </select>
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'timePeriodId'" :hasAppend="false"></qaqcFormFieldSelect>
            </div>
        </fieldset>
    </div>
    <div class="form-group">
        <fieldset :disabled="formDisabled">
            <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
                <button style="margin: 5px" class="btn btn-default" v-on:click="$refs['secondaryCategoryModal'].open()">Secondary Categories</button>
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'secondarySiteTypeList'" :hasAppend="true"></qaqcFormFieldSelect>
            </div>
            <modal ref="secondaryCategoryModal">
                <h3 slot="header">Secondary Property Categories</h3>
                <div slot="body">
                    <div class="form-group">
                        <div class="col-md-12">
                            <checkboxPanel :readonly="!(productionAdminEdit || isFirstOrFullRecord || qaqcEnabled)" :numColumns="4" :lookupList="siteTypeList" ref="siteTypePanel" :fieldName="'siteTypeId'" :suffix="qaqcEnabled ? 'Qaqc' : ''" name="siteTypeCB" />
                        </div>
                    </div>
                </div>
                <div slot="footer">
                    <div class="row">
                        <button name="buttonCancel" class="btn btn-primary col-md-3" v-on:click="$refs['secondaryCategoryModal'].close()">Close</button>
                    </div>
                </div>
            </modal>
            <div class="col-md-2"></div>
            <div class="col-md-4" :class="{'form-inline': qaqcEnabled}">
                <button style="margin: 5px" class="btn btn-default" v-on:click="$refs['secondaryTimePeriodModal'].open()">Secondary Time Periods</button>
                <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'secondaryTimePeriodList'" :hasAppend="true"></qaqcFormFieldSelect>
            </div>
            <modal ref="secondaryTimePeriodModal">
                <h3 slot="header">Secondary Time Periods</h3>
                <div slot="body">
                    <div class="form-group">
                        <div class="col-md-12">
                            <checkboxPanel :readonly="!(productionAdminEdit || isFirstOrFullRecord || qaqcEnabled)" :numColumns="4" :lookupList="timePeriodList" ref="timePeriodPanel" :fieldName="'id'" :suffix="qaqcEnabled ? 'Qaqc' : ''" name="timePeriodCB" />
                        </div>
                    </div>
                </div>
                <div slot="footer">
                    <div class="row">
                        <button name="buttonCancel" class="btn btn-primary col-md-3" v-on:click="$refs['secondaryTimePeriodModal'].close()">Close</button>
                    </div>
                </div>
            </modal>
        </fieldset>
    </div>
    <div v-if="productionAdminEdit" class="form-group">
        <fieldset :disabled="formDisabled">
            <label class="col-md-2 control-label text-label">Is Confidential</label>
            <div class="col-md-4 text-label">
                <input type="checkbox" v-model="culturalResource.isConfidential" class="form-check-input" style="width: 15px; height: 15px;"/>
            </div>
            <label class="col-md-2 control-label text-label">Is Inactive</label>
            <div class="col-md-4 text-label">
                <input type="checkbox" v-model="culturalResource.isInactive" class="form-check-input" style="width: 15px; height: 15px;"/>
            </div>
        </fieldset>
    </div>
    <div v-if="qaqcEnabled || productionAdminEdit" class="form-group">
        <fieldset :disabled="formDisabled">
            <div v-if="culturalResourceRecording.siteTypeId === propertyTypeEnum.District">
                <label  class="col-md-2 control-label text-label">District Ownership Type</label>
                <div class="col-md-4">
                    <select class="form-control" v-model="culturalResourceRecording.districtOwnershipTypeId">
                        <option :value="null" disabled>Select a value</option>
                        <option v-for="type in districtOwnershipTypeList" v-bind:value="type.id" :key="type.id">
                            {{ type.description}}
                        </option>
                    </select>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'districtOwnershipTypeId'" :hasAppend="false"></qaqcFormFieldSelect>
                </div>
            </div>
        </fieldset>
    </div>
    <!-- <div v-else-if="">
        <fieldset :disabled="formDisabled">
            <div v-if="culturalResourceRecording.siteTypeId === propertyTypeEnum.District" class="form-group">
                <label  class="col-md-2 control-label text-label">District Ownership Type</label>
                <div class="col-md-4">
                    <select class="form-control" v-model="culturalResource.districtOwnershipTypeId">
                        <option :value="null" disabled>Select a value</option>
                        <option v-for="type in districtOwnershipTypeList" v-bind:value="type.id" :key="type.id">
                            {{ type.description}}
                        </option>
                    </select>
                </div>
            </div>
        </fieldset>
    </div> -->
    <div v-else class="form-group">
        <fieldset :disabled="formDisabled">
            <div v-if="culturalResourceRecording.siteTypeId === propertyTypeEnum.District" >
                <label class="col-md-2 control-label text-label">District Ownership Type</label>
                <div class="col-md-4 text-label">
                    {{ (districtOwnershipTypeList.find(x => x.id === culturalResourceRecording.districtOwnershipTypeId) || { description: 'None'}).description }}
                </div>
            </div>
        </fieldset>
    </div>
    <div class="form-group" v-if="!productionAdminEdit && !qaqcEnabled">
        <fieldset :disabled="formDisabled">
            <label class="col-md-2 control-label text-label">Attachments</label>
            <div class="col-md-6 text-label">{{ attachmentString }}</div>
        </fieldset>
    </div>
    <div class="form-group">
        <fieldset :disabled="formDisabled">
            <landOwnership :parentId="parentId" :source="source" :formDisabled="formDisabled" />
            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'landownership'" :hasAppend="true"></qaqcFormFieldSelect>
        </fieldset>
    </div>
    <div class="form-group">
        <fieldset :disabled="formDisabled">
            <label class="col-md-2 control-label text-label">Identifiers</label>
            <div class="col-md-10 text-label">
                <table class="table" style="width=100%">
                    <thead>
                        <tr>
                            <th>Edit</th>
                            <th>Type</th>
                            <th>Owner</th>
                            <th>Name</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="identifier in culturalResourceIdentifiers" :key="identifier.index">
                            <td><a class="fa fa-edit" style="font-size: 18px;" :class="{ 'disabled-link': formDisabled }" v-on:click="showEditIdentifier(identifier.culturalResourceIdentifierId)"></a></td>
                            <td>{{identifier.identifierTypeDescription}}</td>
                            <td>{{identifier.parentDescription}}</td>
                            <td>{{identifier.identifier}}</td>
                            <td><a class="fa fa-ban" style="font-size: 18px;" :class="{ 'disabled-link': formDisabled }" v-on:click="deleteIdentifier(identifier.culturalResourceIdentifierId)"></a></td>
                        </tr>
                    </tbody>
                </table>
                <div class="col-md-4">
                    <button v-show="!formDisabled" class="btn btn-default" v-on:click="showAddIdentifier()">Add Identifier</button>
                </div>
                <div class="col-md-4">
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'identifiers'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <modal ref="addIdentifierModal">
                    <h3 slot="header">Cultural Resource Identifier</h3>
                    <div slot="body">
                        <div class="form form-horizontal">
                            <div class="row">
                                <div class="form-group">
                                    <label class="col-md-4 control-label">Type</label>
                                    <div class="col-md-8">
                                        <select class="form-control" v-model="selectedIdentifierTypeId">
                                            <option value=-1>Select a value</option>
                                            <option v-for="identifierType in identifierTypeList" v-bind:value="identifierType.id" :key="identifierType.id">
                                                {{ identifierType.description}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group">
                                    <label class="col-md-4 control-label">Owner</label>
                                    <div class="col-md-8">
                                        <select class="form-control" v-model="currentIdentifier.parentId">
                                            <option value="">Select a value</option>
                                            <option v-for="organization in selectedOrgList" v-bind:value="organization.organizationId" :key="organization.organizationId">
                                                {{ organization.description}}
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="form-group">
                                    <label class="col-md-4 control-label">Identifier</label>
                                    <div class="col-md-8">
                                        <input type="text" class="form-control" v-model="currentIdentifier.identifier">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div slot="footer">
                        <div class="row">
                            <button name="buttonCancel" class="btn btn-primary col-md-3" v-on:click="saveIdentifier()">Save</button>
                            <button name="buttonCancel" class="btn btn-primary col-md-3" v-on:click="$refs['addIdentifierModal'].close()"> Cancel </button>
                        </div>
                    </div>
                </modal>
            </div>
        </fieldset>
    </div>
    <div v-if="isShpoCrApprovingUser || !(qaqcEnabled || formDisabled)" class="form-group">
        <div class="col-md-2">
            <button class="btn btn-primary pull-right" v-on:click="saveOverview">Save</button>
        </div>
    </div>
    <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'identification'" :completeSection="completeSection"></qaqcFormFieldFooter>
</div>
</template>

<script>
import modal from '../Modal.vue'
import loggingService from '../../services/util/loggingService'
import culturalResourceIdentifierService from '../../services/culturalResourceIdentifierService'
import culturalResourceService from '../../services/culturalResourceService'
import culturalResourceRecordingService from '../../services/culturalResourceRecordingService'
import organizationService from '../../services/organizationService'
import lookupService from '../../services/lookup/lookupService'
import siteTypeService from '../../services/lookup/siteTypeService'
import qaqcService from '@/services/qaqcService'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'
import checkboxPanel from '@/components/CheckBoxPanel.vue'
import landOwnership from '@/components/LandOwnership'

export default {

    name: 'identificationForm',
    components: {
        modal,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter,
        landOwnership,
        checkboxPanel
    },
    mounted () {
        loggingService.log(this.isDebug, 'IdentificationForm', 'Mounted')
        if (this.culturalResourceRecording.culturalResourceRecordingId) {
            this.loadData()
        }
        if (this.$refs.notesRef) {
            this.$refs.notesRef.disabled = false
            this.$refs.notesRef.setAttribute('focus', true)
        }
    },
    props: {
        culturalResource: {},
        culturalResourceRecording: {},
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        productionAdminEdit: { default: false },
        source: { default: '' },
        attachmentString: { default: '' },
        recordingOrganization: { default: '' },
        isShpoCr: { default: false },
        isShpoCrApprovingUser: { default: false },
        otherCrrList: { default: () => [] }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                //if there's no location qa/qc object, create new instance
                if (!this.qaqcProgressDto.qaqcSelections.identification) {
                    this.qaqcProgressDto.qaqcSelections.identification = qaqcService.qaqcSelections().identification
                }
                return this.qaqcProgressDto.qaqcSelections.identification
            } else {
                return {}
            }
        },
        parentId: function () {
            if (this.culturalResource && this.source === 'CulturalResource') {
                return this.culturalResource.culturalResourceId
            } else if (this.culturalResourceRecording && this.source === 'CulturalResourceRecording') {
                return this.culturalResourceRecording.culturalResourceRecordingId
            } else {
                return null
            }
        },
        isMigrated: function () {
            return this.culturalResourceRecording.culturalResourceRecordingId < 81838
        },
        isNormalization: function () {
            return +this.culturalResourceRecording.recordingTypeId === +this.recordingTypeEnum.Normalization
        },
        propertyTypeEnum: function () {
            return culturalResourceRecordingService.PropertyTypeEnum
        },
        isFirstOrFullRecord: function () {
            return +this.culturalResourceRecording.recordingTypeId === +this.recordingTypeEnum.FirstRecording ||
                +this.culturalResourceRecording.recordingTypeId === +this.recordingTypeEnum.FullRerecord
        },
        // styling for input width during qaqc
        qaqcInputStype: function () {
            if (this.qaqcEnabled) {
                return { width: '75%' }
            } else {
                return {}
            }
        }
    },
    watch: {
        culturalResource: function () {
            loggingService.log(this.isDebug, 'IdentificationForm', 'cultural resource changed ')
            //this.loadCulturalResourceIdentifiers()
        },
        culturalResourceRecording: function () {
            loggingService.log(this.isDebug, 'IdentificationForm', 'cultural resource recording changed ')
            this.loadData()
        },
        selectedIdentifierTypeId: function () {
            if (this.selectedIdentifierTypeId === 1) {
                this.selectedOrgList = this.organizationList.filter(x => {
                    return x.isLeadAgency
                })
            } else if (this.selectIdentifierTypeId === 3) {
                this.selectedOrgList = this.organizationList.filter(x => {
                    return x.isConsultant
                })
            }
        }
    },
    data: function () {
        return {
            isDebug: false,
            culturalResourceIdentifiers: [],
            identifierTypes: [],
            currentIdentifier: {},
            identifierTypeList: [],
            organizationList: [],
            selectedOrgList: [],
            selectedIdentifierTypeId: '',
            districtOwnershipTypeList: [],
            timePeriodList: [],
            siteTypeList: [],
            recordingTypeEnum: culturalResourceRecordingService.RecordingTypeEnum,
            selectedOtherCrrId: null
        }
    },
    methods: {
        showEditIdentifier (culturalResourceIdentifierId) {
            loggingService.log(this.isDebug, 'IdentificationForm', 'showing edit for ' + culturalResourceIdentifierId)
            this.currentIdentifier = this.culturalResourceIdentifiers.find(x => {
                return (x.culturalResourceIdentifierId === culturalResourceIdentifierId)
            })
            loggingService.log(this.isDebug, 'IdentificationForm', 'found ' + this.currentIdentifier.identifier)
            this.$refs['addIdentifierModal'].open()
        },
        showAddIdentifier () {
            this.currentIdentifier = {
                culturalResourceRecordingId: this.culturalResourceRecording.culturalResourceRecordingId,
                identifierTypeId: -1
            }
            this.$refs['addIdentifierModal'].open()
        },
        loadIdentifierTypes () {
            loggingService.log(this.isDebug, 'IdentificationForm', 'Loading indentifier type')
            return lookupService.listLookup(this.$http, 'IdentifierType').then(response => {
                this.identifierTypeList = response.data
                return response
            })
        },
        loadOrganizations () {
            return organizationService.list(this.$http).then(response => {
                loggingService.log(this.isDebug, 'IdentificationForm', 'loadOrganizations - complete')
                this.organizationList = response.data
                this.selectedOrgList = this.organizationList
            })
        },
        loadDistrictOwnershipTypes () {
            loggingService.log(this.isDebug, 'IdentificationForm', 'Loading district ownership type')
            return lookupService.listLookup(this.$http, 'DistrictOwnershipType').then(response => {
                this.districtOwnershipTypeList = response.data
                return response
            })
        },
        loadTimePeriods () {
            return lookupService.listLookup(this.$http, 'TimePeriod').then(response => {
                this.timePeriodList = response.data
                return response
            })
        },
        loadSiteTypes () {
            return siteTypeService.listLookup(this.$http, 'SiteType').then(response => {
                this.siteTypeList = response.data.map(x => {
                    return {
                        siteTypeId: x.id,
                        description: x.description
                    }
                })
                return response
            })
        },
        loadLookups () {
            return Promise.all([this.loadIdentifierTypes(), this.loadOrganizations(),
                this.loadDistrictOwnershipTypes(), this.loadTimePeriods(), this.loadSiteTypes()]).then(response => {
                    return response
                })
        },
        setSecondarySiteTypes () {
            this.$refs.siteTypePanel.selectedList = this.culturalResourceRecording.secondarySiteTypeList.map(x => { return x.siteTypeId })
        },
        setSecondaryTimePeriods () {
            this.$refs.timePeriodPanel.selectedList = this.culturalResourceRecording.secondaryTimePeriodList.map(x => { return x.timePeriodId })
        },
        loadData () {
            loggingService.log(this.isDebug, 'IdentificationForm', 'loading cultural resource identifiers for ' + this.culturalResource.culturalResourceId)
            var searchDto = {culturalResourceRecordingId: this.culturalResourceRecording.culturalResourceRecordingId}
            return culturalResourceIdentifierService.search(this.$http, searchDto).then(response => {
                loggingService.log(this.isDebug, 'Identification Form', ' cultural resource identifier found: ' + response.data.length)
                this.culturalResourceIdentifiers = response.data
                //set secondary site types
                this.loadLookups().then(response => {
                    this.setSecondarySiteTypes()
                    this.setSecondaryTimePeriods()
                    return response
                })
            })
        },
        saveIdentifier () {
            // set identifierTypeId to user selectedIdentifierTypeId
            this.currentIdentifier.identifierTypeId = this.selectedIdentifierTypeId
            culturalResourceIdentifierService.put(this.$http, this.currentIdentifier).then(result => {
                this.$refs['addIdentifierModal'].close()
                this.loadData()
            })
        },
        deleteIdentifier (culturalResourceIdentifierId) {
            culturalResourceIdentifierService.remove(this.$http, culturalResourceIdentifierId).then(response => {
                this.loadData()
            })
        },
        saveOverview () {
            if (this.productionAdminEdit || this.isFirstOrFullRecord || this.qaqcEnabled) {
                this.culturalResourceRecording.secondarySiteTypeList = this.$refs['siteTypePanel'].selectedList.map(x => {
                    return {siteTypeId: x}
                })
                this.culturalResourceRecording.secondaryTimePeriodList = this.$refs['timePeriodPanel'].selectedList.map(x => {
                    return {timePeriodId: x}
                })
            }
            if (this.productionAdminEdit) {
                culturalResourceService.put(this.$http, this.culturalResource).then(response => {
                    culturalResourceRecordingService.put(this.$http, this.culturalResourceRecording).then(response => {
                        this.$emit('overviewSaved')
                    })
                })
            } else {
                culturalResourceRecordingService.put(this.$http, this.culturalResourceRecording).then(response => {
                    this.$emit('overviewSaved')
                })
            }
        },
        goCulturalResourceGroup () {
            var crrId = this.culturalResourceRecording.culturalResourceRecordingId
            var resourceId = this.culturalResource.resourceId
            var crId = this.culturalResource.culturalResourceId
            this.$router.push({ name: 'CulturalResourceGroup', query: { resourceId: resourceId, culturalResourceRecordingId: crrId, culturalResourceId: crId, prod: this.productionAdminEdit, isEdit: this.productionAdminEdit } })
        },
        checkSelectionComplete (selection) {
            if (this.culturalResourceRecording.siteTypeId === this.propertyTypeEnum.District &&
                selection.districtOwnershipTypeId === 0) return false
            for (let key in selection) {
                if (String(key) !== 'districtOwnershipTypeId' && selection[key] === 0) return false
            }
            return true
        },
        completeSection (sectionName) {
            // check if all selections have been made
            if (this.isFirstOrFullRecord) {
                if (!this.checkSelectionComplete(this.qaqcSelection)) {
                    alert('Please complete all QA/QC selections in this section.')
                    return
                }
            } else {
                if (!this.checkSelectionComplete(this.qaqcSelection)) {
                    alert('Please complete all QA/QC selections in this section.')
                    return
                }
            }
            this.saveOverview()
            this.saveQaqcProgress(sectionName, true)
        },
        goProduction () {
            let routeData = this.$router.resolve({name: 'CulturalResource', params: {culturalResourceId: this.culturalResource.culturalResourceId}})
            window.open(routeData.href, '_blank')
        },
        insertCrrLinkToNotes () {
            if (this.selectedOtherCrrId) {
                this.culturalResourceRecording.shpoCrRecordingNotes = (this.culturalResourceRecording.shpoCrRecordingNotes || '') +
                    `<a href="${window.location.origin}/CulturalResourceRecording/${this.selectedOtherCrrId}">Link to Site Form</a>`
            }
        }
    }
}
</script>

<style>
    .disabled-link {
        pointer-events: none;
    }
</style>



// WEBPACK FOOTER //
// IdentificationForm.vue?f82d69a8